"use strict";

var _interopRequireDefault = require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/dbs/index"));
var _AppMain = _interopRequireDefault(require("./components/AppMain"));
var _Navbar = _interopRequireDefault(require("./components/Navbar"));
var _default = exports.default = {
  name: 'Layout',
  components: {
    Navbar: _Navbar.default,
    AppMain: _AppMain.default,
    Dbs: _index.default
  },
  methods: {
    // 筛选点击
    searchClick: function searchClick() {
      this.$refs['Dbs'].openActionSheet();
    }
  }
};